// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__25pZV","title":"BackImages_title__2tUHW","images":"BackImages_images__edVef"};